export function getPath(): string {
  return window.location.host.includes('localhost:3000')
    ? "http://localhost/cms/"
      //"https://preview.id-ms.de/cms/"
    : "/cms/";
}
